import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "search-widget-content"
};
const _hoisted_2 = { class: "mobile-title" };
const _hoisted_3 = { class: "title" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--close" }, null, -1);
const _hoisted_5 = [
    _hoisted_4
];
const _hoisted_6 = { class: "search-btn" };
const _hoisted_7 = ["placeholder", "onKeyup"];
const _hoisted_8 = ["href"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon--search" }, null, -1);
const _hoisted_10 = {
    key: 0,
    class: "suggester"
};
const _hoisted_11 = {
    key: 0,
    class: "categories"
};
const _hoisted_12 = { class: "title" };
const _hoisted_13 = {
    key: 0,
    class: "categories-list"
};
const _hoisted_14 = ["href"];
const _hoisted_15 = { key: 1 };
const _hoisted_16 = { class: "products" };
const _hoisted_17 = { class: "title" };
const _hoisted_18 = {
    key: 0,
    class: "products-list"
};
const _hoisted_19 = ["href"];
const _hoisted_20 = { class: "image" };
const _hoisted_21 = ["src"];
const _hoisted_22 = { class: "name" };
const _hoisted_23 = { class: "price" };
const _hoisted_24 = {
    key: 0,
    class: "old"
};
const _hoisted_25 = { class: "current" };
const _hoisted_26 = { key: 1 };
import { onMounted, ref, computed } from "vue";
import axios from '../js/helpers/axiosConfig';
import { __ } from '../js/helpers/i18n';
export default /*#__PURE__*/ _defineComponent({
    props: ['autocompleteUrl', 'searchUrl', 'recentProducts', 'recentCategories'],
    setup(__props) {
        const props = __props;
        const query = ref('');
        const suggestions = ref();
        const timeout = ref(null);
        const showSearch = ref(false);
        const queryUrl = computed(() => `${props.searchUrl}?query=${query.value}`);
        const typingCheckInterval = 1000;
        onMounted(() => {
            suggestions.value = {
                products: props.recentProducts,
                categories: props.recentCategories
            };
        });
        const getSuggest = () => {
            if (query.value.length > 2) {
                window.clearTimeout(timeout.value);
                timeout.value = setTimeout(() => {
                    axios.post(props.autocompleteUrl, {
                        query: query.value,
                    }).then(async (response) => {
                        suggestions.value = response.data;
                    }).catch(() => {
                        console.log('error');
                    });
                }, typingCheckInterval);
            }
            else if (query.value.length > 0) {
                suggestions.value = null;
            }
            else {
                suggestions.value = {
                    products: props.recentProducts,
                    categories: props.recentCategories
                };
            }
        };
        const goToQuery = () => {
            window.location.href = queryUrl.value;
        };
        return (_ctx, _cache) => {
            return (showSearch.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(__)('Wyszukiwarka')), 1),
                        _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[0] || (_cache[0] = ($event) => (showSearch.value = !showSearch.value))
                        }, _hoisted_5)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _withDirectives(_createElementVNode("input", {
                            type: "search",
                            autocomplete: "off",
                            placeholder: _unref(__)('Wyszukiwana fraza'),
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((query).value = $event)),
                            onInput: _cache[2] || (_cache[2] = ($event) => (getSuggest())),
                            onKeyup: _withKeys(goToQuery, ["enter"])
                        }, null, 40, _hoisted_7), [
                            [_vModelText, query.value]
                        ]),
                        _createElementVNode("a", {
                            href: _unref(queryUrl),
                            class: "btn-black"
                        }, [
                            _createElementVNode("span", null, _toDisplayString(_unref(__)('Szukaj')), 1),
                            _hoisted_9
                        ], 8, _hoisted_8)
                    ]),
                    (suggestions.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (suggestions.value.categories)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(__)('Kategorie')), 1),
                                    (suggestions.value.categories.length)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestions.value.categories, (category, index) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    class: "category",
                                                    key: index
                                                }, [
                                                    _createElementVNode("a", {
                                                        href: category.url
                                                    }, _toDisplayString(category.name), 9, _hoisted_14)
                                                ]));
                                            }), 128))
                                        ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(__)('Nie znaleziono kategorii')), 1))
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(__)('Produkty')), 1),
                                (suggestions.value.products?.length)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestions.value.products, (product, index) => {
                                            return (_openBlock(), _createElementBlock("li", {
                                                class: "product",
                                                key: index
                                            }, [
                                                _createElementVNode("a", {
                                                    href: product.url
                                                }, [
                                                    _createElementVNode("div", _hoisted_20, [
                                                        _createElementVNode("img", {
                                                            src: product.image?.breakpoints.default.webp || '/themes/default/images/placeholder_70x70.png'
                                                        }, null, 8, _hoisted_21)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_22, _toDisplayString(product.name), 1),
                                                    _createElementVNode("div", _hoisted_23, [
                                                        (product.oldPrice)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(product.oldPrice), 1))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("div", _hoisted_25, _toDisplayString(product.currentPrice), 1)
                                                    ])
                                                ], 8, _hoisted_19)
                                            ]));
                                        }), 128))
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_unref(__)('Nie znaleziono produktów')), 1))
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
